import { render, staticRenderFns } from "./landingRobotics.vue?vue&type=template&id=18eb6670&scoped=true&"
import script from "./landingRobotics.vue?vue&type=script&lang=js&"
export * from "./landingRobotics.vue?vue&type=script&lang=js&"
import style0 from "./landingRobotics.vue?vue&type=style&index=0&id=18eb6670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb6670",
  null
  
)

export default component.exports